class CartDrawer extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      
    
      const isMobile = (window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent));
      
      /* if(varianAbTest =="A"){
        return;
      }else if(!isMobile && varianAbTest == "B"){
        return;
      } */
      if(!isMobile){
        return;
      }

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    }, 1000);
  
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      //data-cart-mobile
      
      const isMobile = (window.innerWidth <= 768 || /Mobi|Android/i.test(navigator.userAgent)) ; 
      if(!isMobile){
        this.classList.add('animate', 'active');
      }else{
        this.classList.add('active');
        const cartDrawerItems = this.querySelector('cart-drawer-items');
        if (cartDrawerItems) {
          const productRecommendations = document.querySelector('.cart-item');
          renderRecommendations(productRecommendations);
          cartDrawerItems.checkScrollNeeded(cartDrawerItems);
        }
      
      
    }});

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  /* handleScroll(event) {
    
    const container = event.target;
    const scrollPosition = container.scrollTop + container.clientHeight;
    const scrollHeight = container.scrollHeight;
    if (container.clientHeight >= scrollHeight) {
      this.classList.add('near-bottom');
      return;
    }
    const scrollPercentage = (scrollPosition / scrollHeight) * 100;

    if (scrollPercentage >= 80) {
      console.log('Llegaste al 80% del scroll');
      this.classList.add('near-bottom');
    }else{
      console.log('Estás por encima del 80% del scroll');
      this.classList.remove('near-bottom');
    }
  } */
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.addEventListener('scroll', this.handleScroll.bind(this));
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
  checkScrollNeeded(container) {
    const footer = document.querySelector('.drawer__footer');
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;
    if (clientHeight >= scrollHeight) {
      footer.classList.add('near-bottom');
    } else {
      footer.classList.remove('near-bottom');
    }
  }

  handleScroll(event) {
    const container = this;

    // Asegurar que el buffer de valores existe
    if (!this.scrollBuffer) {
        this.scrollBuffer = [];
    }

    const scrollTop = container.scrollTop;
    const scrollPosition = scrollTop + container.clientHeight;
    const scrollHeight = container.scrollHeight;
    const currentPercentage = (scrollPosition / scrollHeight) * 100;

    // Agregar el valor actual al buffer
    this.scrollBuffer.push(currentPercentage);

    // Mantener solo los últimos 5 valores
    if (this.scrollBuffer.length > 5) {
        this.scrollBuffer.shift();
    }

    // Calcular el promedio de los últimos valores
    const averagePercentage = this.scrollBuffer.reduce((a, b) => a + b, 0) / this.scrollBuffer.length;

    if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
    }

    this.scrollTimeout = setTimeout(() => {
        const footer = document.querySelector('.drawer__footer');
        if (!footer) return; // Evitar errores si no existe el footer

        const SHOW_THRESHOLD = 80; // Mostrar el footer cerca del final
        const HIDE_THRESHOLD = 70; // Bajar más el umbral para facilitar ocultarlo

        // Redondear porcentaje
        const roundedPercentage = Math.round(averagePercentage * 10) / 10;

        console.log(`Scroll estable al ${roundedPercentage}%`);

        if (scrollTop === 0) {
            footer.classList.remove('near-bottom');
            console.log('Usuario en el tope - Ocultando footer');
            this.scrollBuffer = []; // Resetear buffer para evitar valores antiguos
            return;
        }

        // Mostrar footer si el scroll está alto
        if (roundedPercentage >= SHOW_THRESHOLD) {
            if (!footer.classList.contains('near-bottom')) {
                footer.classList.add('near-bottom');
                console.log('Mostrando footer');
            }
        } 
        // Ocultar footer si el scroll baja lo suficiente
        else if (roundedPercentage < HIDE_THRESHOLD) {
            if (footer.classList.contains('near-bottom')) {
                footer.classList.remove('near-bottom');
                console.log('Ocultando footer');
                
                // Reset del buffer para evitar valores altos antiguos
                this.scrollBuffer = [];
            }
        }
    }, 200); // Delay para evitar parpadeos
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);

function renderRecommendations(container){
  if(!container) return;
  const productRecommendations = container.getAttribute('data-cart-item-id');

  
fetch(window.Shopify.routes.root + "recommendations/products?product_id="+productRecommendations+"&limit=14&section_id=product-recommendations&intent=related")
 .then(response => response.text())
 .then((text) => {
    setTimeout(() => {
      let productRecommendationsSection = document.getElementById('cart-drawer__footer__recommendations__products');

      let html = document.createElement('div');
      html.innerHTML = text;
      let recommendations = html.querySelector('.product-recomendations');
      if (recommendations) {
        productRecommendationsSection.innerHTML = "";
        productRecommendationsSection.innerHTML = recommendations.innerHTML;
      }
    }, 1000);
 });
}

/* document.addEventListener('cart-update-remove', () => {
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  if (cartDrawerItems) {
    cartDrawerItems.checkScrollNeeded(cartDrawerItems);
  }
}); */
